import moment from 'moment';

import { formatDate } from '../services/dateUtils';

export type SortDirection = 'asc' | 'desc';

export const queryParamNames = {
    startDate: 'start',
    endDate: 'end',
    includeRioAccounts: 'includeRio',
    search: 'search',
    sort: 'sort',
    sortDirection: 'direction',
} as const;

export const getDefaultStartDate = () =>
    formatDate(moment().date() < 7 ? moment().subtract(1, 'month').startOf('month') : moment().startOf('month'));

export const getDefaultEndDate = () => formatDate(moment().endOf('day'));

export const isDateQueryParam = (value: string | null): value is string =>
    value !== null && moment(value, 'YYYY-MM-DD', true).isValid();

export const getSharedSearch = (search: string): string => {
    const currentParams = new URLSearchParams(search);
    const sharedParams = new URLSearchParams();
    const startDate = currentParams.get(queryParamNames.startDate);
    const endDate = currentParams.get(queryParamNames.endDate);

    sharedParams.set(queryParamNames.startDate, isDateQueryParam(startDate) ? startDate : getDefaultStartDate());
    if (isDateQueryParam(endDate)) {
        sharedParams.set(queryParamNames.endDate, endDate);
    }
    if (currentParams.get(queryParamNames.includeRioAccounts) === 'true') {
        sharedParams.set(queryParamNames.includeRioAccounts, 'true');
    }

    const query = sharedParams.toString();
    return query ? `?${query}` : '';
};

export const withSearch = (pathname: string, search: string) => ({ pathname, search });
